"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingPatientInfo = exports.LoadingProvider = void 0;
var Provider_1 = require("./Provider");
Object.defineProperty(exports, "LoadingProvider", { enumerable: true, get: function () { return __importDefault(Provider_1).default; } });
var PatientInfo_1 = require("./PatientInfo");
Object.defineProperty(exports, "LoadingPatientInfo", { enumerable: true, get: function () { return __importDefault(PatientInfo_1).default; } });
//# sourceMappingURL=index.js.map